import config from 'veui/managers/config'

config.defaults(
  {
    ui: {
      display: {
        values: ['inline']
      }
    }
  },
  'form'
)
